import React, { useState, useEffect } from 'react'
import { Container, Col, Row, Image,Card } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BigLoaders from "../components/BigLoaders";
import { apiUrl } from "../commons/inFormTypes";
import { IPUrl } from "../commons/IPAddress";

function InternalImage() {
    const [snip, setSnip] = useState(false);
    const [seenFile, setSeenFile] = useState([]);
    let { requestId } = useParams();
    const userToken = localStorage.getItem("user_token");
    const navigate = useNavigate()

    useEffect(() => {
        if (userToken == null) {
            navigate("/");
        } else {
            const axios = require("axios");
            setSnip(true);
            axios
                .post(apiUrl + "Get_Educate", {
                    id: requestId,
                    TokenId: userToken,
                })

                .then((res) => {
                    setSnip(false);
                    if (res.data.result === "true") {
                        setSeenFile(res.data.data)
                    } else {
                    }
                })
                .catch(function (error) {
                    if (error.response) {
                        toast.error(error.response.data.message, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                });

        }
    }, [requestId]);

    return (
        <div>
            <Container>
            <BigLoaders loads={snip} />
                <Row className="justify-content-center pt-5">
                            <Col xs={12} lg={8} >
                                <Card className="rgc-internal-news">
                                    <Image variant="top" src={IPUrl + seenFile.Picture}  />
                                    <Card.Body>
                                        <div className="meta-news">
                                            <ul>
                                                <li>
                                                    <i className="fa fa-calendar"></i>{" "}
                                                    <span className="text-meta"> {seenFile.Tarikh}</span>
                                                </li>

                                                <li className="hidden-xs hidden-print">
                                                    <i className="fa fa-print"></i>
                                                    <span className="title-meta">چاپ</span>
                                                </li>
                                            </ul>
                                        </div>
                                        <Card.Title>
                                            {seenFile.Title}
                                        </Card.Title>
                                        <Card.Text>
                                            {seenFile.Comment}
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                </Row>
            </Container>
        </div>
    )
}

export default InternalImage